import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { config } from '../config';

@Injectable({
  providedIn: 'root'
})

export class AssetService {


  public fileDetails = new Subject<any>();
  public closeFile = new Subject<any>();
  public formData = new Subject<any>();

  constructor(private http: HttpClient) { }




  addAssetType(data: any): Observable<any> {
    console.log("Adding Asset-Type", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "asset-category", data).subscribe((res: any) => {
        console.log("response in service--->", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });

  }


  editAssetType(data): Observable<any> {
    return new Observable<any>((observer) => {
      console.log('edit data', data)
      console.log("Observable");
      this.http.put(config.baseApiUrl + "asset-category", data).subscribe((res: any) => {
        console.log("Edited Asset Type : ", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }


  getAssetType(): Observable<any> {
    console.log('asset get list work')
    // console.log("Adding clients", id);
    var that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "asset-category").subscribe((res: any) => {
        console.log("Get Assets : ", res);
        observer.next(res.data);
      }, (err) => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });

  }


  getSingleAssetType(id): Observable<any> {
    console.log('asset get list work')
    // console.log("Adding clients", id);
    var that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "asset-category?_id=" + id).subscribe((res: any) => {
        console.log("Get Assets : ", res);
        observer.next(res.data.obj);
      }, (err) => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });

  }


  deleteAssetType(id): Observable<any> {
    return new Observable<any>((observer) => {
      console.log('delte data', id)
      console.log("Observable");
      this.http.delete(config.baseApiUrl + "asset-category?_id=" + id).subscribe((res: any) => {
        console.log("Delete Asses Type : ", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }









  // ASSETS API CALL


  getAssetsDashboard(): Observable<any> {
    var that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "asset-category/asset-deshboard-details/").subscribe((res: any) => {
        console.log("Get Assets : ", res);
        observer.next(res.data);
      }, (err) => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });

  }



  createNewAsset(data: any): Observable<any> {
    console.log("Adding Asset-Type", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "asset-category/asset/", data).subscribe((res: any) => {
        console.log("response in service--->", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });

  }



  editAsset(data: any): Observable<any> {
    console.log("Adding Asset-Type", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "asset-category/asset/", data).subscribe((res: any) => {
        console.log("response in service--->", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });

  }


  deleteAsset(id): Observable<any> {
    return new Observable<any>((observer) => {
      console.log('delte data', id)
      console.log("Observable");
      this.http.delete(config.baseApiUrl + "asset-category/asset/?_id=" + id).subscribe((res: any) => {
        console.log("Delete Asses Type : ", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }



  getSingleAssetData(id): Observable<any> {
    console.log('asset get list work')
    console.log("Adding clients", id);
    let obj = {
      assetId: id
    }
    var that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "asset-category/single-asset/", obj).subscribe((res: any) => {
        console.log("Get Assets : ", res);
        observer.next(res.data);
      }, (err) => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });

  }

  getOtherCategoryAssets(id, flag, singleAssetcat): Observable<any> {
    console.log('asset get list work')
    console.log("Adding clients", id);
    let obj = {
      assetTypeId: id,
      flag: flag,
      singleAssetcat: singleAssetcat
    }
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "asset-category/other-category-assets", obj).subscribe((res: any) => {
        console.log("Get Assets : ", res);
        observer.next(res.data);
      }, (err) => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });

  }


  //  Asset allocation to user 


  allocateAsset(data: any): Observable<any> {
    console.log("Adding Asset-Type", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "asset-category/asset-allocation/", data).subscribe((res: any) => {
        console.log("response in service--->", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });

  }

  unAllocateAsstes(data: any): Observable<any> {
    console.log("Adding Asset-Type", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "asset-category/asset-un-allocation/", data).subscribe((res: any) => {
        console.log("response in service--->", res);
        observer.next(res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });

  }

  submitAssetForm(data): Observable<any> {
    console.log("data in main service", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "asset-category/asset-submission/", data).subscribe((res: any) => {
        console.log("Edited form: ", res);
        observer.next(res);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }

  getInspectionFormData(data): Observable<any> {
    console.log('asset get list work')
    // console.log("Adding clients", id);
    var that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "asset-category/asset-submission/", data).subscribe((res: any) => {
        console.log("Get Assets : ", res);
        this.formData.next(res)
        observer.next(res);
      }, (err) => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });

  }



  getUserAssetsList(id): Observable<any> {
    console.log('asset get list work')
    // console.log("Adding clients", id);
    var that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "asset-category/assets-list/?_id=" + id).subscribe((res: any) => {
        console.log("Get Assets for assetlist : ", res);
        observer.next(res.data);
      }, (err) => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });

  }





  /**
   * single users pdf download
   */
  downloadAssetPdf(data): Observable<any> {
    // var that = this;

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "asset-category/assets-download", data).subscribe((res: any) => {
        console.log("Get Assets : ", res);
        observer.next(res.data);
      }, (err) => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }


  /**
   * single asset all form zip download
   * ***********================**************
   */

  downloadAssetZip(data): Observable<any> {
    // var that = this;

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "asset-category/assetszip-download", data).subscribe((res: any) => {
        console.log("Get Assets : ", res);
        observer.next(res.data);
      }, (err) => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }


  getAssetallocationList(data): Observable<any> {
    console.log("Adding location", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "asset-category/allocateto-list?_query=" + data).subscribe((res: any) => {
        // console.log("Received Sending = ", res.data.location)
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }


  displayFile(data) {
    console.log("EVENT OF OPEN FILE", data);
    this.fileDetails.next(data)

  }

  closeDisplayFile(data) {
    console.log("data------>", data);

    this.closeFile.next(data)
  }

  closeFileDetailsObservable(): Observable<any> {
    return this.closeFile.asObservable();
  }


  fileDetailsObservable(): Observable<any> {
    return this.fileDetails.asObservable();
  }

  formDataAsObservable(): Observable<any> {
    return this.formData.asObservable();
  }

  // FIXED ASSET API CALLS


  // Create new asset for fixed asset management

  createFixedAsset(data: any): Observable<any> {
    console.log("Adding Asset-Type", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "fixed-asset/", data).subscribe((res: any) => {
        observer.next(res.data);
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          observer.complete();
        })
    });
  }


  // Edit asset details
  editFixedAsset(data: any): Observable<any> {
    console.log("Adding Asset-Type", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "fixed-asset/", data).subscribe((res: any) => {
        observer.next(res.data);
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          observer.complete();
        })
    });
  }

  // Get asset list for admin user
  getFixedAssetList(): Observable<any> {
    console.log('asset get list work')
    // console.log("Adding clients", id);
    var that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "fixed-asset/?_type=fixedAsset").subscribe((res: any) => {
        console.log("Get Assets : ", res);
        observer.next(res.data);
      }, (err) => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });

  }

  // Delete created asset from database
  deleteFixedAsset(id): Observable<any> {
    return new Observable<any>((observer) => {
      console.log('delte data', id)
      console.log("Observable");
      this.http.delete(config.baseApiUrl + "fixed-asset/?_id=" + id).subscribe((res: any) => {
        console.log("Delete Asses Type : ", res);
        observer.next(res);
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  // Get the single asset details
  getSingleFixedAssetData(id): Observable<any> {
    var that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "fixed-asset/?_id=" + id).subscribe((res: any) => {
        console.log("Get Assets : ", res);
        observer.next(res.data);
      }, (err) => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }

  // Upload multiple documents in fixed asset
  uploadAssetDocument(data: any): Observable<any> {
    console.log("Adding Asset-Type", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "fixed-asset/upload-documents/", data).subscribe((res: any) => {
        observer.next(res.data);
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          observer.complete();
        })
    });
  }


  // remove fixed asset uploaded documents
  deleteFixedAssetDocument(id): Observable<any> {
    return new Observable<any>((observer) => {
      console.log('delte data', id)
      console.log("Observable");
      this.http.delete(config.baseApiUrl + "fixed-asset/upload-documents/?_id=" + id).subscribe((res: any) => {
        console.log("Delete Asses Type : ", res);
        observer.next(res.data);
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  // Download zip file for asset documents
  downloadAssetDocumentsZip(data): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "fixed-asset/download-documents", data).subscribe((res: any) => {
        console.log("Get Assets : ", res);
        observer.next(res.data);
      }, (err) => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }

  getSubmissoisForFixedAsset(id): Observable<any> {
    let item = JSON.stringify(id)
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "fixed-asset/submission-list?_id=" + item).subscribe((res: any) => {
        console.log("Get Courses : ", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        observer.error(err)

      }, () => {
        observer.complete()
      })
    });
  }


  // Download single form submission or all form submission for single asset
  downloadAssetSubmission(data): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "fixed-asset/download-submission", data).subscribe((res: any) => {
        console.log("Get Assets : ", res);
        observer.next(res.data);
      }, (err) => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }

  downloadVehicleAssetMatrix(assetCategoryId): Observable<any> {
    console.log("Adding location", assetCategoryId);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "asset-category/asset-matrix-download?_id=" + assetCategoryId).subscribe((res: any) => {
        // console.log("Received Sending = ", res.data.location)
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }





  // PLANT ASSET API CALLS START


  getAssetDashboardDetails(weekId?): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("Observable");
      let item = JSON.stringify(weekId)
      this.http.get(config.baseApiUrl + "fixed-asset/dashboard?_weekId=" + item).subscribe((res: any) => {
        console.log("Get Courses : ", res);
        observer.next(res);
        // observer.complete();
      }, err => {
        observer.error(err)

      }, () => {
        observer.complete()
      })
    });
  }


  getPlantAssetList(): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "fixed-asset/?_type=plantAsset").subscribe((res: any) => {
        console.log("Get Assets : ", res);
        observer.next(res.data);
      }, (err) => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }

  downloaFixedAssetDashboard(data): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("Observable");
      let item = JSON.stringify(data)
      this.http.post(config.baseApiUrl + "fixed-asset/dashboard-download", data).subscribe((res: any) => {
        // console.log("Received Sending = ", res.data.location)
        observer.next(res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }


  // PLANT ASSET API CALLS END


}
